import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import CircularLoader from './icons/CircularLoader';
var Loader = function () {
    return (_jsx("div", { className: "fixed inset-0 flex justify-center items-center z-[100] bg-slate-50/60", children: _jsx(CircularLoader, {}) }));
};
export default Loader;
